import { Heading } from "@aidron/aidron-ds";

import { CustomText } from "../../../../../components/StyledComponents/styleComponents.index";

import OppAnalysis from "../../../../../assets/image/_analise-oportunidades.png";
import AdjustmentPlan from "../../../../../assets/image/_otimizacao-de-sortimento.png";

import PropTypes from 'prop-types';

export function OuterCardHeading({ ctx, uiState }) {

  const { title, text, } = ctx || {};
  const { adjustmentPlan = false } = uiState || {};

  if(adjustmentPlan) {
    return (
      <div className="ms-1 mb-4" style={{ display: "flex", flexDirection: "row", alignItems: "center", gap: "1rem" }}>
        <img src={AdjustmentPlan} style={{ width: "7%", height: "7%" }}/>

        <div>
          <Heading size="sm">{title.toUpperCase()}</Heading>
          <CustomText margin="0" size="xs" color="orange">
            {text}
          </CustomText>
        </div>
      </div>
    );
  }

  return (
    <div className="ms-1 mb-4" style={{ display: "flex", flexDirection: "row", alignItems: "center", gap: "1rem" }}>
      <img src={OppAnalysis} style={{ width: "7%", height: "7%" }}/>

      <div>
        <Heading size="sm">{title.toUpperCase()}</Heading>
        <CustomText margin="0" size="xs" color="orange">
          {text}
        </CustomText>        
      </div>
    </div>
  );
}

OuterCardHeading.propTypes = { ctx: PropTypes.shape(), uiState: PropTypes.shape() }